// extracted by mini-css-extract-plugin
export default {"search__area":"CitySearch_search__area__5MI2L","search__area__input":"CitySearch_search__area__input__xaGcY","search__area__btn":"CitySearch_search__area__btn__nzI4K"};